import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog-video',
  templateUrl: './confirm-dialog-video.component.html',
  styleUrls: ['./confirm-dialog-video.component.css']
})
export class ConfirmDialogVideoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
